<template>
  <main>
    <dsf-text>
      This is your shell, now you are able to connect µFs to your application
    </dsf-text>
    <RouterView />
  </main>
</template>

<script lang="ts" setup>
import { RouterView } from 'vue-router'

import '@sennder/design-system-core/dist/styles/themes/default.css'
import '@sennder/design-system-core'
</script>
